import React from 'react';
import { Loading } from 'components/atoms/loading';

export const loadingRender = (): JSX.Element => <Loading />;
